/* unplugin-vue-components disabled */import script from "./TimeManagementOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeManagementOverview.vue?vue&type=script&setup=true&lang=js"

import "./TimeManagementOverview.vue?vue&type=style&index=0&id=386c08d2&lang=scss"

const __exports__ = script;

export default __exports__